export interface FileInfo {
  name: string
  suffix: string
  url: string
}

export const newFileInfo = (): FileInfo => ({
  name: '',
  suffix: '',
  url: '',
})
